import * as THREE from './three'

export const DEG2RAD = THREE.MathUtils.DEG2RAD
export const RAD2DEG = THREE.MathUtils.RAD2DEG
